module.exports = __webpack_public_path__ + "static/img/11.2b32061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/11.png
// module id = rzCB
// module chunks = 35